module.exports = __webpack_public_path__ + "img/icon_up-fa0b3124.svg";